import COLORS from '@/constants/colors';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import CloseIcon from '@mui/icons-material/Close';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { useEditableImageViewController } from './EditableImageViewController';

export function EditableImage(props: {
  productId: string;
  skuId: string;
  image?: string;
}) {
  const { uiState, actions, references } = useEditableImageViewController({
    productId: props.productId,
    skuId: props.skuId,
    savedImage: props.image,
  });

  return (
    <>
      <Box
        key={props.productId}
        onClick={actions.onClickedTableRowImage}
        sx={{
          cursor: uiState.imageEditable ? 'pointer' : undefined,
          textAlign: 'center',
        }}
      >
        {uiState.savedImage ? (
          <img
            src={uiState.savedImage}
            width={50}
            height={50}
            style={{
              objectFit: 'contain',
            }}
            alt="The product"
          />
        ) : (
          <InsertPhotoOutlinedIcon
            sx={{ width: '30px', height: '30px', color: '#8c8c8c' }}
          />
        )}
      </Box>
      <Dialog open={uiState.showDialog ?? false} onClose={actions.closeDialog}>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Stack>
            <DialogTitle>Cargar Foto</DialogTitle>
            <Typography
              sx={{ mx: '24px', fontSize: '14px', color: COLORS.gray_600 }}
            >
              Formatos soportados: JPG, JPEG y PNG
            </Typography>
          </Stack>

          <IconButton
            aria-label="delete"
            onClick={actions.closeDialog}
            sx={{ height: '40px', width: '40px', mr: '16px' }}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
        <DialogContent>
          <Box
            sx={{
              width: { xs: '200px', lg: '400px' },
              height: { xs: '200px', lg: '400px' },
              backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='11' ry='11' stroke='%230000001A' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");`,
              borderRadius: '12px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              position: 'relative',
              alignItems: 'center',
            }}
          >
            {uiState.dialogImage ? (
              <>
                <img
                  src={uiState.dialogImage}
                  alt={`productimage`}
                  style={{ width: '70%', height: '70%' }}
                />
                <IconButton
                  size="large"
                  onClick={actions.onClickedEditImage}
                  sx={{ position: 'absolute', bottom: 12 }}
                >
                  <EditOutlinedIcon />
                </IconButton>
              </>
            ) : (
              <IconButton size="large" onClick={actions.onClickedEditImage}>
                <AddPhotoAlternateOutlinedIcon />
              </IconButton>
            )}
            <input
              type="file"
              ref={references.fileInputRef}
              onChange={actions.handleFileChange}
              accept=".png,.jpg,.jpeg"
              style={{ display: 'none' }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            onClick={actions.closeDialog}
            disabled={uiState.cancelDisabled}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={actions.onClickedSave}
            disabled={uiState.saveDisabled}
          >
            {uiState.isSaving ? (
              <CircularProgress color="inherit" size="22px" />
            ) : (
              'Guardar'
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
